module.exports = __webpack_public_path__ + "img/cy_13.png";